query GetPreviousInvoices {
    previousInvoices {
        id
        amount
        status
        date
    }
}
